import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useParser = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/parser/list", filter)
      setItems(response.data.parsers);
      setTotal(response.data.total);
      return response.data.parsers
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/parser/all", requestData)
      setItems(response.data.parsers);
      setTotal(response.data.total);
      return response.data.parsers
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/parser/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (parser, count) => {
    try {
      const requestData = {
        parser: parser,
        count: count,
      };

      const response = await automobyApi.post("/parser/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/parser/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          parser_id: id
        };
        const response = await automobyApi.post(`/parser/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

 

  const parserService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { parserService };
}